import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { eliminarBloque } from '../../store/slices/bloque';

type Props = {
    open: boolean
    setOpen: any
}

const EliminarBloque = ({open, setOpen}: Props) => {

    const dispatch = useDispatch<AppDispatch>();

    const { bloque } = useSelector((state: RootState) => state.bloque);

    const handleEliminarBloque = () => {
        dispatch(eliminarBloque(bloque.bid));
        setOpen(false);
    }

    return (
        <div>
            <Dialog
                open={open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    ¿Estás seguro de eliminar el bloque <b>{`"${bloque.nombre}"`}</b>?
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Esta operación es <b>irreversible</b>, si eliminas este bloque
                        no podrás recuperar su información.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>Cancelar</Button>
                    <Button onClick={handleEliminarBloque} autoFocus>
                        Eliminar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}



export default EliminarBloque;

